import { type FC } from 'react';
import { type ModalProps } from '~/modal/modalType.enum';
import {
  useMapSettingsSearchIsStackingItemsAllowedSelector, useMapSettingsSearchMatchingBehaviorSelector,
  useMapSettingsSearchShouldMatchExactWordsSelector, useMapSettingsSearchShouldZoomOnMatchesSelector,
} from '~/store/mapSettings/search/mapSettingsSearch.selectors';
import {
  type SavePayload, SearchSettingsModalComponent,
} from './searchSettingsModal.component';

export type SearchSettingsModalContainerProps = ModalProps<{
  onSave: (params: SavePayload) => void;
}>;

export const SearchSettingsModalContainer: FC<SearchSettingsModalContainerProps> = (props) => {
  const itemStackingAllowed = useMapSettingsSearchIsStackingItemsAllowedSelector();
  const selectedMatchingBehaviourState = useMapSettingsSearchMatchingBehaviorSelector();
  const shouldZoomOnMatchesState = useMapSettingsSearchShouldZoomOnMatchesSelector();
  const shouldMatchExactWordsState = useMapSettingsSearchShouldMatchExactWordsSelector();

  return (
    <SearchSettingsModalComponent
      {...props}
      matchesStackingAllowed={itemStackingAllowed}
      selectedMatchingBehaviourState={selectedMatchingBehaviourState}
      shouldZoomOnMatchesState={shouldZoomOnMatchesState}
      shouldMatchExactWordsState={shouldMatchExactWordsState}
    />
  );
};
